export default {
  // User info
  'account.center.userId': 'User ID',
  'account.center.username': 'Username',
  'account.center.status': 'Status',
  'account.center.status.active': 'Active',
  'account.center.roles': 'Roles',
  'account.center.lastLogin': 'Last Login',
  'account.center.createdAt': 'Registered',
  'account.center.copyFailed': 'Copy failed',

  // Tab
  'account.center.tab.overview': 'Overview',
  'account.center.tab.team': 'My Team',
  'account.center.tab.records': 'Records',

  // Referral
  'account.center.referral.title': 'Referral',
  'account.center.referral.myCode': 'My Referral Code',
  'account.center.referral.copy': 'Copy',
  'account.center.referral.copyCode': 'Copy referral code',
  'account.center.referral.copyLink': 'Copy referral link',
  'account.center.referral.copyLinkBtn': 'Copy Link',
  'account.center.referral.copied': 'Referral code copied',
  'account.center.referral.linkCopied': 'Referral link copied',
  'account.center.referral.notBound': 'You have not bound a referral code',
  'account.center.referral.bindNow': 'Bind Now',
  'account.center.referral.boundTo': 'Bound referral code',
  'account.center.referral.bindSuccess': 'Referral code bound successfully',
  'account.center.referral.bindFailed': 'Binding failed, please retry',
  'account.center.referral.invalidCode': 'Invalid or non-existent referral code',
  'account.center.referral.alreadyBound': 'You have already bound a referral code',
  'account.center.referral.selfNotAllowed': 'Cannot bind your own referral code',

  // Bind modal
  'account.center.referral.bindModal.title': 'Bind Referral Code',
  'account.center.referral.bindModal.label': 'Referral Code',
  'account.center.referral.bindModal.placeholder': 'Enter 6-character referral code',
  'account.center.referral.bindModal.required': 'Please enter referral code',
  'account.center.referral.bindModal.format': 'Referral code must be 6 alphanumeric characters',
  'account.center.referral.bindModal.cancel': 'Cancel',
  'account.center.referral.bindModal.submit': 'Confirm',

  // Downlines
  'account.center.downlines.title': 'Direct Referrals',
  'account.center.downlines.direct': 'Direct Referrals',
  'account.center.downlines.userId': 'User ID',
  'account.center.downlines.email': 'Email',
  'account.center.downlines.joinedAt': 'Joined At',
  'account.center.downlines.totalCount': 'Total {total} members',
  'account.center.downlines.empty': 'No direct referrals yet',

  // Level info
  'account.center.level.activated': 'Activated',
  'account.center.level.notActivated': 'Not Activated',
  'account.center.level.activateHint': 'You need to activate at least one card to participate in referral rewards',
  'account.center.level.activatedCards': 'Activated Cards',
  'account.center.level.myActivatedCards': 'My Activated Cards',
  'account.center.level.myCardsHint': 'Number of cards you have activated. Activate a card to unlock referral rewards.',
  'account.center.level.upgradeToNext': 'Upgrade to {level}',
  'account.center.level.directCount': 'Direct Referrals',
  'account.center.level.teamCards': 'Team Cards',

  // Earnings
  'account.center.earnings.total': 'Total Earnings',
  'account.center.earnings.pending': 'Pending',
  'account.center.earnings.claimed': 'Claimed',
  'account.center.earnings.frozen': 'Frozen',
  'account.center.earnings.claim': 'Claim',
  'account.center.earnings.claimSuccess': 'Successfully claimed ${amount}',
  'account.center.earnings.claimFailed': 'Claim failed',
  'account.center.earnings.noPending': 'No pending earnings to claim',
  'account.center.earnings.breakdown': 'Earnings Breakdown',
  'account.center.earnings.direct': 'Direct Rewards',
  'account.center.earnings.levelDiff': 'Level Diff Rewards',
  'account.center.earnings.teamBonus': 'Team Bonus',

  // Commission records
  'account.center.commission.records': 'Commission Records',
  'account.center.commission.column.time': 'Time',
  'account.center.commission.column.rewardType': 'Reward Type',
  'account.center.commission.column.sourceType': 'Source',
  'account.center.commission.column.amount': 'Amount',
  'account.center.commission.column.baseAmount': 'Base Amount',
  'account.center.commission.column.rate': 'Rate',
  'account.center.commission.column.status': 'Status',

  // Reward types
  'account.center.commission.type.direct': 'Direct',
  'account.center.commission.type.levelDiff': 'Level Diff',
  'account.center.commission.type.teamBonus': 'Team Bonus',

  // Source types
  'account.center.commission.source.cardActivated': 'Card Activated',
  'account.center.commission.source.rechargeFee': 'Recharge Fee',
  'account.center.commission.source.withdrawal': 'Withdrawal',

  // Status
  'account.center.commission.status.pending': 'Pending',
  'account.center.commission.status.frozen': 'Frozen',
  'account.center.commission.status.settled': 'Settled',
  'account.center.commission.status.claimed': 'Claimed',
};
